export default {
	styleOverrides: {
		root: {
			backdropFilter: 'blur(10px)',
		},
		paper: {
			width: 'min(375px, 100%)',
			background: 'rgba(255,255,255,0.7)',
			padding: '16px 8px',
			borderRadius: '20px',
		},
	},
};
